import { Component, Input, OnInit } from '@angular/core';
import { Direction } from '@angular/cdk/bidi';
import {
  NgbActiveModal,
  NgbModal
} from '@ng-bootstrap/ng-bootstrap';
import {
  UntypedFormControl,
  Validators,
  UntypedFormGroup,
  UntypedFormBuilder,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { CommonModule, formatDate } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import Swal from 'sweetalert2';
import { RestClientService } from '@core/service/rest-client.service';
import { UtilitiesService } from '@core/service/utilities.service';
import { ErrorMessageService } from '@core/service/error-message.service';
import { AuthService } from '@core';
import { FormDialogComponent as ModalAddClient } from '../../../administration/utilisateur-client/form-dialog/form-dialog.component';
import { FormDialogComponent as ModalAddApporteur } from '../../../administration/utilisateur-apporteur/form-dialog/form-dialog.component';
import moment from 'moment';
import { IntegerFormatPipe } from '@core/pipe/integer-format.pipe';
import { BsDatepickerConfig, BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { frLocale } from 'ngx-bootstrap/locale';
import { MatTabGroup, MatTab, MatTabChangeEvent } from "@angular/material/tabs";
import { ShoppingArticleComponent } from "@shared/shopping-article/shopping-article.component";
import { ShoppingFoodComponent } from "@shared/shopping-food/shopping-food.component";
import { PrintService } from '@core/service/print.service';
export interface DialogData {
  id: number;
  action: string;
  item: any;
  type_service_codification: any
}

defineLocale('fr', frLocale);

@Component({
  selector: 'app-modal-prolongation-sejour',
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    IntegerFormatPipe,
    BsDatepickerModule,
    MatTabGroup,
    MatTab,
    ShoppingFoodComponent,
    ShoppingArticleComponent
  ],
  templateUrl: './modal-prolongation-sejour.component.html',
  styleUrl: './modal-prolongation-sejour.component.scss'
})
export class ModalProlongationSejourComponent implements OnInit {
  @Input() data: any = {};
  action: string = '';
  dialogTitle!: string | undefined;
  // bookingForm: UntypedFormGroup;
  // booking: Article;
  client_search_key: any
  apporteur_search_key: any
  itemToSave: any = {};
  itemsNationnalite: any = [
    { user_nationnalite_name: 'IVOIRIENNE', user_nationnalite_id: 'IVOIRIENNE' },
    { user_nationnalite_name: 'BURKINABE', user_nationnalite_id: 'BURKINABE' },
    { user_nationnalite_name: 'SENEGALAIS', user_nationnalite_id: 'SENEGALAIS' },
  ]
  itemsNaturePiece: any = [
    { nature_piece_name: 'CARTE_IDENTITE', user_nature_of_piece: 'CARTE_IDENTITE' },
    { nature_piece_name: 'PASSEPORT', user_nature_of_piece: 'PASSEPORT' },
    { nature_piece_name: 'PERMIS_CONDUIRE', user_nature_of_piece: 'PERMIS_CONDUIRE' },
  ]
  createMessage = ''
  editMessage = ''
  deleteMessage = ''
  gender = 'M'
  entity = 'booking';
  isLoading: boolean = false;
  itemsRoom: any;
  endPoint: string = "hebergement";
  title = 'prolongation séjour'


  itemClient: any = {}
  user: any = {};
  itemsReservation: any = [];

  itemsService: any = [];
  itemsChambre: any = [];
  itemsClient: any = [];
  itemsApporteur: any = [];

  imageDisplay: any;
  imageName: string | undefined;
  currentItemImage: {
    fileBase64: any;
    fileName: any;
    extension: any;
    typeDocument: string;
  } | undefined;
  loading: boolean | undefined;
  itemsModeReglement: any = [];
  itemsUserCaisse: any;
  clientFidelite: any = null;
  showTimeFiels: boolean = false;
  duree_jours: any = 0;
  duree_heures: any = 0;
  itemsTypeReservation: any = [];
  itemsTypeHebergement: any = [];
  current_service: any = {};

  myDate!: Date;
  minDate!: Date;
  maxDate!: Date;
  datePickerConfig?: Partial<BsDatepickerConfig>;
  indice: number = 0;
  selected_chambre: any = [];

  constructor(
    public activeModal: NgbActiveModal,
    private fb: UntypedFormBuilder,
    private restClient: RestClientService,
    private utilities: UtilitiesService,
    private errorMessage: ErrorMessageService,
    private authService: AuthService,
    public printService: PrintService,
    private modalService: NgbModal
  ) {
    // if (this.action === 'edit') {
    //   this.dialogTitle = '';
    //   this.itemToSave = {
    //     ...this.data.item
    //   };
    //   console.log("this.itemToSave: ", this.itemToSave)
    //   if (this.data.item?.image_url) {
    //     this.imageDisplay = this.data.item?.image_url;
    //   }

    //   this.onSearchClient(this.itemToSave.client_id)
    //   // this.getItemsImagesArticle()
    //   this.getItemsService()
    //   // this.getitemsChambre()
    //   this.onSearchApporteur()
    // } else {
    //   this.dialogTitle = ' ';
    //   this.itemToSave = {}
    //   this.itemToSave.type_service_codification = this.data.type_service_codification
    // }
    this.user = this.authService.getCurrentUser();
    let text1 = this.gender == 'M' ? 'un' : 'une';
    this.createMessage = 'Vous êtes sur le point de créer ' + text1 + ' ' + this.title;
    this.editMessage = 'Vous êtes sur le point de modifier ' + text1 + ' ' + this.title;
    this.deleteMessage = 'Vous êtes sur le point de supprimer ' + text1 + ' ' + this.title;

    const today = new Date();
    this.myDate = new Date();
    this.minDate = today;
    const future = new Date();
    future.setDate(future.getDate() + 30);
    this.maxDate = future;
    this.datePickerConfig = {
      minDate: this.minDate,
      maxDate: this.maxDate,
      keepDatesOutOfRules: true,
      dateInputFormat: 'DD/MM/YYYY'
    };
  }

  ngOnInit() {
    this.action = this.data?.action;
    console.log('data: ', this.data);
    this.itemToSave = { ...(this.data?.item || {}) };
    console.log("this.itemToSave: ", this.itemToSave);
    if (this.data.item?.image_url) {
      this.imageDisplay = this.data.item?.image_url;
    }
    this.itemToSave.date_debut_formatted = moment(this.itemToSave.date_debut).format('DD/MM/YYYY');
    this.itemToSave.date_fin_formatted = moment(this.itemToSave.date_fin).format('DD/MM/YYYY');
    this.onSearchClient(this.itemToSave.client_id);
    this.onSearchApporteur();
    this.getItemsReservation();
    this.getItemsModeReglement();
    this.getitemsUserCaisse();
    this.getItemsTypeHebergement();
    if (this.itemToSave.client_id) this.getClientFidelite(this.itemToSave.client_id);
  }

  submit() {

  }

  onTabChange(event: MatTabChangeEvent) {
    console.log('event.index: ', event.index)
    this.indice = event.index
  }


  confirmSaveItem(item: any) {

    if (!this.itemToSave.client_id) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner client svp",
        "bottom",
        "center"
      );
      return
    }
    if (this.current_service.codification == 'PASS') {
      if (!this.itemToSave.montant_avance || this.itemToSave.montant_avance < this.itemToSave.montant_total) {
        this.utilities.showNotification(
          "snackbar-danger",
          "Veuillez reclamer la totalité en cas de passage svp!",
          "bottom",
          "center"
        );
        return
      }
    }

    // if (!this.itemToSave.montant_avance || !(this.itemToSave.montant_avance > 0)) {
    //   this.utilities.showNotification(
    //     "snackbar-danger",
    //     "Veuillez reclamer la totalité ou une avance svp!",
    //     "bottom",
    //     "center"
    //   );
    //   return
    // }

    if (!item.id)
      item.code = this.generateUniqueString()
    let objToSave = Object.assign({}, item);
    Swal.fire({
      title: this.capitalize(this.title),
      text: objToSave?.id
        ? this.editMessage
        : this.createMessage,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0665aa',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui',
      cancelButtonText: 'Non',
    }).then((result) => {
      if (result.value) {
        // objToSave.code = objToSave.code.trim().toUpperCase();
        this.saveItem(objToSave);
      }
    });
  }
  onControlAvanceField() {
    if (this.current_service.codification == 'PASS' && !this.itemToSave.montant_avance || this.itemToSave.montant_avance < this.itemToSave.montant_total) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez reclamer la totalité en cas de passage svp!",
        "bottom",
        "center"
      );
      return
    }

    if (!this.itemToSave.montant_avance || !(this.itemToSave.montant_avance > 0)) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez reclamer la totalité ou une avance svp!",
        "bottom",
        "center"
      );
      return
    }
  }

  saveItem(item: any) {
    console.info("item to save", item);

    this.isLoading = true;

    let itemAEnregistrer = Object.assign({}, item);

    if (this.currentItemImage && Object.keys(this.currentItemImage).length) {
      itemAEnregistrer.file_data = this.currentItemImage;
    } else {
      delete itemAEnregistrer.file_data;
    }

    let reduce = [];

    // itemAEnregistrer.groupe_id = this.user.groupe_id
    // itemAEnregistrer.hotel_id = this.user.hotel_id


    itemAEnregistrer.duree_heures = this.diffHours(this.itemToSave.heure_debut, this.itemToSave.heure_fin_prolongement);
    itemAEnregistrer.heure_fin = this.itemToSave.heure_fin_prolongement;
    let new_duration = moment(this.itemToSave.date_fin).diff(moment(this.itemToSave.date_debut), 'days', true)
    let service_price = this.selected_chambre.montant_service
    console.log('new_duration: ', new_duration)
    console.log('service_price: ', service_price)
    console.log('this.itemToSave.date_fin: ', this.itemToSave.date_fin)
    console.log('this.itemToSave.date_debut: ', this.itemToSave.date_debut)
    console.log("this.selected_chambre.montant_service: ", this.selected_chambre.montant_service)
    itemAEnregistrer.montant_total = moment(this.itemToSave.date_fin).diff(moment(this.itemToSave.date_debut), 'days', true) * this.selected_chambre.montant_service

    console.log("moment(this.itemToSave.date_fin).diff(moment(this.itemToSave.date_debut), 'days', true): ", moment(this.itemToSave.date_fin).diff(moment(this.itemToSave.date_debut), 'days', true))
    console.log("itemAEnregistrer.montant_total: ", itemAEnregistrer.montant_total)
    // itemAEnregistrer.date_fin = moment(this.itemToSave.date_fin).add(this.itemToSave.duree_supplementaire, 'days').toDate();

    delete itemAEnregistrer.duree_heures
    delete itemAEnregistrer.heure_debut
    delete itemAEnregistrer.heure_fin
    delete itemAEnregistrer.heure_debut_prolongement
    delete itemAEnregistrer.heure_fin_prolongement
    var request = {
      is_prolongement: true,
      datas: [itemAEnregistrer],
    };

    this.restClient
      .post(
        this.endPoint + "" + (itemAEnregistrer.id ? "/update" : "/create"),
        request
      )
      .subscribe(
        (res: any) => {
          console.info("resul", res);
          this.isLoading = false;

          if (!res["hasError"]) {
            this.utilities.showNotification(
              "snackbar-success",
              this.utilities.formatMsgServeur(res["status"]["message"]),
              "bottom",
              "center"
            );
            // this.currentPage = 0
            this.activeModal.close(res.item)

          } else {
            if (res["status"] && res["status"]["message"]) {
              this.utilities.showNotification(
                "snackbar-danger",
                this.utilities.formatMsgServeur(res["status"]["message"]),
                "bottom",
                "center"
              );
            }
          }
        },
        (err) => {
          this.utilities.showNotification(
            "snackbar-danger",
            this.utilities.getMessageEndPointNotAvailble(),
            "bottom",
            "center"
          );
          this.loading = false;
        }
      );
  }

  getItemsReglementHebergement(item: any) {
    this.itemsChambre = []
    let request = {
      data: {
        hebergement_id: item.hebergement_id
      },
      index: 0,
      size: 10000,
    };

    this.restClient
      .post("reglementHebergement/getByCriteria", request)
      .subscribe(
        (res: any) => {
          if (res && res["items"] && !res['hasError']) {
            this.imprimerReglement(res.items[0])

          } else {
            this.utilities.showNotification(
              "snackbar-danger",
              this.utilities.formatMsgServeur(res["status"]["message"]),
              "bottom",
              "center"
            );
          }
        },
        (err) => {

        }
      );
  }

  imprimerReglement(item: any) {
    let request = {
      data: {
        // telephone:this.client_search_key
        id: item.id
      },
      index: 0,
      size: 10000,
    };

    this.restClient
      .post("pdf/printRecuHebergement", request)
      .subscribe(
        (res: any) => {
          if (res && res["item"] && !res['hasError']) {

            this.printService.previewPdf(res['item'].link)

          } else {
            this.utilities.showNotification(
              "snackbar-danger",
              this.utilities.formatMsgServeur(res["status"]["message"]),
              "bottom",
              "center"
            );
          }
        },
        (err) => {

        }
      );
  }


  getItemsReservation() {
    this.itemsChambre = []
    let request = {
      type_reservation_codification: 'CHAMBRE',
      data: {
      },
      index: 0,
      size: 10000,
    };

    this.restClient
      .post("reservation/getByCriteria", request)
      .subscribe(
        (res: any) => {
          if (res && res["items"] && !res['hasError']) {
            this.itemsReservation = res["items"];
            this.itemsReservation = this.itemsReservation.filter((ir: any) => ir.statut_code !== 'HEBERGEMENT' && ir.statut_code !== 'ANNULE' && ir.statut_code !== 'SORTIE' && !ir.is_bloquee && !ir.is_confirmee && ir.can_be_hebergement)
          } else {
            this.utilities.showNotification(
              "snackbar-danger",
              this.utilities.formatMsgServeur(res["status"]["message"]),
              "bottom",
              "center"
            );
            this.itemsReservation = [];
          }
        },
        (err) => {
          this.itemsReservation = [];

        }
      );
  }
  getItemsModeReglement() {
    // this.itemsChambre = []
    let request = {
      data: {
      },
      index: 0,
      size: 10000,
    };

    this.restClient
      .post("modeReglement/getByCriteria", request)
      .subscribe(
        (res: any) => {
          if (res && res["items"] && !res['hasError']) {
            this.itemsModeReglement = res["items"];

          } else {
            this.utilities.showNotification(
              "snackbar-danger",
              this.utilities.formatMsgServeur(res["status"]["message"]),
              "bottom",
              "center"
            );
            this.itemsModeReglement = [];
          }
        },
        (err) => {
          this.itemsModeReglement = [];

        }
      );
  }

  uploadFile(event: any) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const file = event.target.files[0];
      const fileName = file.name.split(".")[0];
      const Tabextension = file.name.split(".");
      const extension = Tabextension[Tabextension.length - 1];

      console.info("fileName", fileName);
      console.info("extension", extension);
      this.imageName = fileName + "." + extension;
      reader.onload = (readerEvent) => {
        const data = (readerEvent.target as any).result;
        this.imageDisplay = data;
        const fileBase64 = data.split(",")[1];
        this.currentItemImage = {
          fileBase64: fileBase64,
          fileName: fileName,
          extension: extension,
          typeDocument: "custom type",
        };
      };
    }

    reader.readAsDataURL(event.target.files[0]);
  }

  getItemsChambre() {
    this.itemToSave.heure_debut_prolongement = ''
    this.itemToSave.heure_fin_prolongement = ''

    this.itemToSave.date_debut_prolongement = ''
    this.itemToSave.date_fin_prolongement = ''
    this.itemToSave.montant_supplementaire = ''
    console.log('calling getitemsChambre() ')
    this.itemsChambre = [];
    if (!this.itemToSave.service_id || !this.itemToSave.date_debut || !this.itemToSave.date_fin) return
    console.log('1')
    if (!this.itemToSave.duree_supplementaire || !(this.itemToSave.duree_supplementaire > 0)) return
    console.log('2')

    let request: any = {
      data: {
      },
      index: 0,
      size: 10000,
    };

    request.chambre_status = 'AVAILABLE'// POUR RECUPER UNIQUEMENT LES CHAMBRES DISPONIBLES
    request.service_id = this.itemToSave.service_id
    request.debut_reservation = this.itemToSave.date_fin
    request.fin_reservation = moment(this.itemToSave.date_fin).add(this.itemToSave.duree_supplementaire, 'days').toDate();

    this.restClient
      .post("chambre/getByCriteria", request)
      .subscribe(
        (res: any) => {
          if (res && res["items"] && !res['hasError']) {
            this.itemsChambre = res["items"];

            let is_chambre_in_list = !!this.itemsChambre.find((ic: any) => ic.id == this.itemToSave.chambre_id)
            // debugger
            if (!is_chambre_in_list) {
              this.utilities.showNotification(
                "snackbar-danger",
                "Chambre non disponible pour cette prolongation",
                "bottom",
                "center"
              );
            }
            else {
              this.selected_chambre = this.itemsChambre.find((ic: any) => ic.id == this.itemToSave.chambre_id)
              // this.itemToSave.heure_debut_prolongement = this.extractTime(request.debut_reservation) 
              // this.itemToSave.heure_fin_prolongement = this.extractTime(request.fin_reservation)

              this.itemToSave.date_debut_prolongement = request.debut_reservation
              this.itemToSave.date_fin_prolongement = request.fin_reservation
              this.itemToSave.date_fin = request.fin_reservation

              this.itemToSave.date_debut_prolongement_formatted = moment(this.itemToSave.date_debut_prolongement).format('DD/MM/YYYY')
              this.itemToSave.date_fin_prolongement_formatted = moment(this.itemToSave.date_fin_prolongement).format('DD/MM/YYYY')
              this.itemToSave.montant_supplementaire = this.itemToSave.duree_supplementaire * this.selected_chambre.montant_service

              console.log("this.itemToSave: ", this.itemToSave)
            }



          } else {
            this.utilities.showNotification(
              "snackbar-danger",
              this.utilities.formatMsgServeur(res["status"]["message"]),
              "bottom",
              "center"
            );
            this.itemsChambre = [];
          }
        },
        (err) => {
          this.itemsChambre = [];

        }
      );
  }

  getitemsUserCaisse() {

    let request = {
      add_solde_info: true,
      add_caisse_status: true,
      data: {
        user_id: this.user.id,
        hotel_id: this.user.hotel_id
      },
      index: 0,
      size: 10000,
    };

    this.restClient
      .post("userCaisse/getByCriteria", request)
      .subscribe(
        (res: any) => {
          if (res && res["items"] && !res['hasError']) {
            this.itemsUserCaisse = res["items"];
            this.itemsUserCaisse = this.itemsUserCaisse.filter((ic: any) => ic.is_open)

          } else {
            this.utilities.showNotification(
              "snackbar-danger",
              this.utilities.formatMsgServeur(res["status"]["message"]),
              "bottom",
              "center"
            );
            this.itemsUserCaisse = [];
          }
        },
        (err) => {
          this.itemsUserCaisse = [];

        }
      );
  }

  onSearchClient(client_id?: any) {

    // if(!this.client_search_key) return
    let request = {
      chambre_status: 'AVAILABLE',// POUR RECUPER UNIQUEMENT LES CHAMBRES DISPONIBLES
      service_id: this.itemToSave.service_id,
      debut_reservation: this.itemToSave.date_debut,
      fin_reservation: this.itemToSave.date_fin,
      search_key: this.client_search_key,
      data: {
        // telephone:this.client_search_key
        id: client_id
      },
      index: 0,
      size: 10000,
    };

    this.restClient
      .post("client/getByCriteria", request)
      .subscribe(
        (res: any) => {
          if (res && res["items"] && !res['hasError']) {
            this.itemsClient = res["items"];
            if (client_id)
              this.itemToSave.client_id = client_id

          } else {
            this.utilities.showNotification(
              "snackbar-danger",
              this.utilities.formatMsgServeur(res["status"]["message"]),
              "bottom",
              "center"
            );
            this.itemsClient = [];
          }
        },
        (err) => {
          this.itemsClient = [];

        }
      );
  }
  // onGetChambreDisponible() {

  //   // this.itemToSave.chambre_id = null
  //   this.getitemsChambre()
  // }

  onResetHours() {
    this.itemToSave.date_debut = moment()
    this.itemToSave.date_fin = moment()
    this.itemToSave.heure_debut = moment().format('HH:mm');
    this.itemToSave.heure_fin = moment().format('HH:mm');
    this.itemToSave.duree_heures = 0
    this.itemToSave.duree_supplementaire = 0
  }



  resetFields() {
    this.itemToSave.chambre_id = null
    // this.itemToSave.client_id=null
    this.itemToSave.montant_total = null
    // this.itemToSave.heure_debut=null
    // this.itemToSave.heure_fin=null
    // this.itemToSave.date_debut_reservation=null
    // this.itemToSave.date_fin_reservation=null
    // this.itemToSave.duree_heures=null
  }


  // onSetDurationBasedOnTime(){
  //   if (this.current_service.codification == 'PASS' && this.itemToSave.heure_debut && this.itemToSave.heure_fin) {
  //     const start = moment(this.itemToSave.date_debut, 'HH:mm');
  //     const end = moment(this.itemToSave.date_fin, 'HH:mm');

  //     const diffHours = end.diff(start, 'hours'); // difference in full hours
  //     console.log(diffHours); 
  //     this.itemToSave.duree_heures = diffHours

  //     const baseDateDebut = moment(this.itemToSave.date_debut).startOf('day');
  //     const [heureDebut, minuteDebut] = this.itemToSave.heure_debut.split(':').map(Number);
  //     this.itemToSave.date_debut = baseDateDebut.clone().add(heureDebut, 'hours').add(minuteDebut, 'minutes');

  //     // Parse and apply end time
  //     const baseDateFin = moment(this.itemToSave.date_fin).startOf('day');
  //     const [heureFin, minuteFin] = this.itemToSave.heure_fin.split(':').map(Number);
  //     this.itemToSave.date_fin = baseDateFin.clone().add(heureFin, 'hours').add(minuteFin, 'minutes');


  //   }
  //    this.onGetChambreDisponible()
  // }




  // openDialog(action: 'add' | 'edit', data?: any) {
  //   let varDirection: Direction;
  //   if (localStorage.getItem('isRtl') === 'true') {
  //     varDirection = 'rtl';
  //   } else {
  //     varDirection = 'ltr';
  //   }
  //   const modalRef = this.modalService.open(MyDialog, {
  //   const modalRef = this.modalService.open(MyDialog, {
  //     windowClass: 'modal-xxl',
  //     centered: true,
  //   });
  //   modalRef.componentInstance.data = { item: data, action };

  //   dialogRef.closed.subscribe((result) => {
  //     console.log("result: ", result)
  //     if (result && result.id)
  //       this.onSearchClient(result.id)
  //   });
  // }

  openAddClientModal(action: 'add' | 'edit', data?: any) {
    let varDirection: Direction;
    if (localStorage.getItem('isRtl') === 'true') {
      varDirection = 'rtl';
    } else {
      varDirection = 'ltr';
    }
    const modalRef = this.modalService.open(ModalAddClient, {
      size: 'xl',
      windowClass: 'modal-xxl',
      centered: true,
    });
    modalRef.componentInstance.data = { item: data, action };
    modalRef.closed.subscribe((result: any) => {
      console.log("result: ", result)
      if (result && result.id)
        this.onSearchClient(result.id)
    });
  }
  openAddApporteurModal(action: 'add' | 'edit', data?: any) {
    let varDirection: Direction;
    if (localStorage.getItem('isRtl') === 'true') {
      varDirection = 'rtl';
    } else {
      varDirection = 'ltr';
    }
    const modalRef = this.modalService.open(ModalAddApporteur, {
      size: 'xl',
      windowClass: 'modal-xxl',
      centered: true,
    });
    modalRef.componentInstance.data = { item: data, action };
    modalRef.closed.subscribe((result: any) => {
      console.log("result: ", result)
      // if (result && result.id)
      //   this.onSearchApporteur(result.id)
    });
  }

  onSearchApporteur() {
    // if(!this.client_search_key) return
    let request = {
      search_key: this.apporteur_search_key,
      data: {
        // telephone:this.client_search_key
        // id: apporteur_id
      },
      index: 0,
      size: 10000,
    };

    this.restClient
      .post("apporteur/getByCriteria", request)
      .subscribe(
        (res: any) => {
          if (res && res["items"] && !res['hasError']) {
            this.itemsApporteur = res["items"];

          } else {
            this.utilities.showNotification(
              "snackbar-danger",
              this.utilities.formatMsgServeur(res["status"]["message"]),
              "bottom",
              "center"
            );
            this.itemsApporteur = [];
          }
        },
        (err) => {
          this.itemsApporteur = [];

        }
      );
  }
  generateUniqueString() {
    var timestamp = new Date().getTime();
    var randomNumber = Math.floor(Math.random() * 1000000);

    var uniqueString = timestamp.toString() + randomNumber.toString();
    return uniqueString;
  }
  capitalize(str: any) {
    return str.replace(/^\w/, (c: string) => c.toUpperCase());
  }

  getClientFidelite(clientId: number) {
    this.restClient.post('client/getByCriteria', { data: { id: clientId }, index: 0, size: 1 })
      .subscribe((res: any) => {
        if (res && !res['hasError'] && res['items']?.length) {
          this.clientFidelite = res['items'][0].fidelite ?? null;
        }
      });
  }

  isFidelitySelected(): boolean {
    const selected = this.itemsModeReglement?.find((m: any) => m.id == this.itemToSave.mode_reglement_id);
    return selected?.codification === 'FIDELITY';
  }

  canUseFidelity(): boolean {
    if (!this.clientFidelite) return false;
    const montantEquiv = this.clientFidelite.montant_equivalent ?? 0;
    const montantARegler = this.itemToSave.montant_avance ?? 0;
    return montantEquiv >= montantARegler;
  }

  onCalculateMonnaie() {
    // debugger
    if (this.itemToSave.montant_avance > 0 && this.itemToSave.montant_recu > 0 && this.itemToSave.montant_recu > this.itemToSave.montant_avance) {
      this.itemToSave.monnaie_rendue = this.itemToSave.montant_recu - this.itemToSave.montant_avance
    }
    if (this.itemToSave.montant_avance > this.itemToSave.montant_recu) {
      this.itemToSave.montant_recu = this.itemToSave.montant_avance
      this.itemToSave.monnaie_rendue = 0
    }
  }



  // getItemsService() {
  //   this.itemsChambre = []
  //   let request = {
  //     data: {
  //     },
  //     index: 0,
  //     size: 10000,
  //   };

  //   this.restClient
  //     .post("service/getByCriteria", request)
  //     .subscribe(
  //       (res: any) => {
  //         if (res && res["items"] && !res['hasError']) {
  //           this.itemsService = res["items"];

  //         } else {
  //           this.utilities.showNotification(
  //             "snackbar-danger",
  //             this.utilities.formatMsgServeur(res["status"]["message"]),
  //             "bottom",
  //             "center"
  //           );
  //           this.itemsService = [];
  //         }
  //       },
  //       (err) => {
  //         this.itemsService = [];

  //       }
  //     );
  // }




  getItemsTypeHebergement() {
    this.itemsChambre = []
    let request = {
      data: {
      },
      index: 0,
      size: 10000,
    };

    this.restClient
      .post("typeHebergement/getByCriteria", request)
      .subscribe(
        (res: any) => {
          if (res && res["items"] && !res['hasError']) {
            this.itemsTypeHebergement = res["items"];

          } else {
            this.utilities.showNotification(
              "snackbar-danger",
              this.utilities.formatMsgServeur(res["status"]["message"]),
              "bottom",
              "center"
            );
            this.itemsTypeHebergement = [];
          }
        },
        (err) => {
          this.itemsTypeHebergement = [];

        }
      );
  }

  diffHours(startTime: any, endTime: any) {
    const start = moment(startTime, "HH:mm");
    const end = moment(endTime, "HH:mm");

    return end.diff(start, "hours", true); // true = résultat décimal
  }

  diffDays(startDate: any, endDate: any) {
    return moment(endDate).diff(moment(startDate), 'days');
  }

  extractTime(datetime: any) {
    return moment(datetime).format("HH:mm");
  }

  diffDaysTime(startDatetime: any, endDatetime: any) {
    const start = moment(startDatetime);
    const end = moment(endDatetime);

    const duration = moment.duration(end.diff(start));

    const days = duration.days();
    const hours = duration.hours();
    const minutes = duration.minutes();

    return {
      days: days,
      hours: hours,
      minutes: minutes
    };
  }
}
